module.exports = __webpack_public_path__ + "178557bc7b8990962b2c9cddb3705eab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/trumpet-s.png
// module id = 2142
// module chunks = 0